export enum EmbedLayout {
  MINI = 0,
  COMPACT = 1,
  FULL = 2,
}

export function convertEmbedLayout(layout: EmbedLayout | number): 'mini' | 'compact' | 'full' {
  switch (layout) {
    case 0:
    case EmbedLayout.MINI:
      return 'mini';
    case 1:
    case EmbedLayout.COMPACT:
      return 'compact';
    default:
      return 'full';
  }
}
